import { ParcelData } from './ParcelData';
import { Agent } from './Agent';
import { ParcelAssessment } from './ParcelAssessment';
import { HistoricListing } from './HistoricListing';

export interface IListingDetail {
    ParcelData?: ParcelData;
    IsLoggedIn: boolean; // false,
    SystemId: number; // 202006416,
    PID: string; // "00416388",
    MapPID: string; // "00416388",
    HistoricListings: HistoricListing[] | null;
    ParcelAssessments: ParcelAssessment[] | null;
    IsResidential: boolean; // false,
    IsFarm: boolean; // false,
    IsCommercial: boolean; // false,
    MlsNo: string; // "202006416",
    ListingService: string; // "mls",
    ClassShort: string; // "MF",
    ClassLong: string; // "Multi-Unit",
    ClassCodeL: number; // 3,
    PreviewImageURL: string; // "https://data.remaxnova.com/propimages/202006416.jpg?1587399511800",
    Address: string; // "219 Rocky Lake Drive, Bedford",
    City: any; // ?? null,
    Province: any; // ? null,
    Latitude: number; // 44.737148,
    Longitude: number; // -63.649724,
    ListPrice: number; // 349000,
    SoldPrice: any; // ?? null,
    NumRnUnits: any; // ?? null,
    NumStories: any; // ? null,
    Parking: any; // ? null,
    Garage: string; // "N",
    ListDate: string; // "\/Date(1587340800000)\/",
    ListDateStr: string; // "Apr 20 2020",
    FirmDate: any; // ?? null,
    FirmDateStr: string; // "---",
    UpdateDate: string; // "\/Date(1597151101800)\/",
    UpdateStr: string; // "Aug 11 2020",
    HeatingCoolingType: string; // "---",
    VirTourURL: any; // null,
    Utillities: string; // "---",
    SewageGroundSpill: string; // "---",
    TotalFinishedSqFt: any; // ?? "null,
    WaterSource: string; // "---",
    ListStatus: string; // "FOR SALE",
    ListStatusCode: number; // 1,
    Type: string; // "Other",
    Style: string; // "---",
    Community: string; // "BEDFORD",
    District: string; // "20",
    HasBuildingSpecs: boolean; // ":false,
    Rooms: string[]; // [],
    PropOvervw: string;
    PropertyImages: string[]; // ["https://data.remaxnova.com/propimages/202006416.jpg?1587399511800"],
    Agents: Agent[];
    ListingOfficeName: string; // "Coldwell Banker Supercity Realty",
    OpenHouses: any; // ?? [],
    HasFlyer: boolean; // false,
    FlyerUrl: any; // ?? null,
    BuildingAge: any; // ?? null,
    SqFootage: any; // ?? null,
    NumBeds: number; // 0,
    FullBaths: number; // 0,
    HalfBaths: number; // 0,
    PropDir: any; // ?? null,
    Foundation: string; // "---",
    Roof: string; // "---",
    ExternalFinish: string; // "---",
    Flooring: string; // "---",
    GarageDetails: string; // null,
    Inclusions: any; // ?? null,
    Exclusions: any; // ?? null,
    HasLatitudeLongitude: boolean; // false,
    PostalCode: string; // "B4A 2S9",
    ExpireDate: any; // ? null,
    ExpireDateStr: string; // "---",
    DaysOnMarket: number; // 147,
    Brokerage: string; // "Coldwell Banker Supercity Realty",
    ListingOfficeId: number; // 187,
    ElemSchool: string; // "Basinview Drive Community School",
    ElemSchoolFr: string; // "Sunnyside (Early)",
    MidSchool: string; // "Rocky Lake Junior High School",
    MidSchoolFr: string; // "Rocky Lake Junior High School",
    HighSchool: string; // "Charles P. Allen High School",
    HighSchoolFr: string; // "Charles P. Allen High (Late)",
    CondoFee: any; // ?? null,
    NewConstruction: boolean; // false
}


export class ListingDetail implements IListingDetail {
    public ParcelData?: ParcelData;
    public IsLoggedIn = false;
    public SystemId = -1;
    public PID = '';
    public MapPID = '';
    public HistoricListings = null;
    public ParcelAssessments = null;
    public IsResidential = false;
    public IsFarm = false;
    public IsCommercial = false;
    public MlsNo = '';
    public ListingService = '';
    public ClassShort = '';
    public ClassLong = '';
    public ClassCodeL = -1;
    public PreviewImageURL = '';
    public Address = '';
    public City = null;
    public Province = null;
    public Latitude = -1;
    public Longitude = -1;
    public ListPrice = -1;
    public SoldPrice = null;
    public NumRnUnits = null;
    public NumStories = null;
    public Parking = null;
    public Garage = '';
    public ListDate = '';
    public ListDateStr = '';
    public FirmDate = null;
    public FirmDateStr = '';
    public UpdateDate = '';
    public UpdateStr = '';
    public HeatingCoolingType = '';
    public VirTourURL = null;
    public Utillities = '';
    public SewageGroundSpill = '';
    public TotalFinishedSqFt = null;
    public WaterSource = '';
    public ListStatus = '';
    public ListStatusCode = -1;
    public Type = '';
    public Style = '';
    public Community = '';
    public District = '';
    public HasBuildingSpecs = false;
    public Rooms = [];
    public PropOvervw = '';
    public PropertyImages = [];
    public Agents = [];
    public ListingOfficeName = '';
    public OpenHouses = null;
    public HasFlyer = false;
    public FlyerUrl = null;
    public BuildingAge = null;
    public SqFootage = null;
    public NumBeds = -1;
    public FullBaths = -1;
    public HalfBaths = -1;
    public PropDir = null;
    public Foundation = '';
    public Roof = '';
    public ExternalFinish = '';
    public Flooring = '';
    public GarageDetails = '';
    public Inclusions = null;
    public Exclusions = null;
    public HasLatitudeLongitude = false;
    public PostalCode = '';
    public ExpireDate = null;
    public ExpireDateStr = '';
    public DaysOnMarket = -1;
    public Brokerage = '';
    public ListingOfficeId = -1;
    public ElemSchool = '';
    public ElemSchoolFr = '';
    public MidSchool = '';
    public MidSchoolFr = '';
    public HighSchool = '';
    public HighSchoolFr = '';
    public CondoFee = null;
    public NewConstruction = false;
    constructor(
        listingDetail: any,
    ) {
        if (listingDetail.parcelData) {
            this.ParcelData = new ParcelData(listingDetail.parcelData);
        }
        this.IsLoggedIn = listingDetail.isLoggedIn;
        this.SystemId = listingDetail.systemId;
        this.PID = listingDetail.pid;
        this.MapPID = listingDetail.mapPID;
        if (listingDetail.historicListings && listingDetail.historicListings.length) {
            this.HistoricListings = listingDetail.historicListings.map((historicObj: any) => new HistoricListing(historicObj));
        }
        if (listingDetail.parcelAssessments && listingDetail.parcelAssessments.length) {
            this.ParcelAssessments = listingDetail.parcelAssessments.map((assessmentObj: any) => new ParcelAssessment(assessmentObj));
        }
        this.IsResidential = listingDetail.isResidential;
        this.IsFarm = listingDetail.isFarm;
        this.IsCommercial = listingDetail.isCommercial;
        this.MlsNo = listingDetail.mlsNo;
        this.ListingService = listingDetail.listingService;
        this.ClassShort = listingDetail.classShort;
        this.ClassLong = listingDetail.classLong;
        this.ClassCodeL = listingDetail.classCode;
        this.PreviewImageURL = listingDetail.previewImageURL;
        this.Address = listingDetail.address;
        this.City = listingDetail.city;
        this.Province = listingDetail.province;
        this.Latitude = listingDetail.latitude;
        this.Longitude = listingDetail.longitude;
        this.ListPrice = listingDetail.listPrice;
        this.SoldPrice = listingDetail.soldPrice;
        this.NumRnUnits = listingDetail.numRnUnits;
        this.NumStories = listingDetail.numStories;
        this.Parking = listingDetail.parking;
        this.Garage = listingDetail.garage;
        this.ListDate = listingDetail.listDate;
        this.ListDateStr = listingDetail.listDateStr;
        this.FirmDate = listingDetail.firmDate;
        this.FirmDateStr = listingDetail.firmDateStr;
        this.UpdateDate = listingDetail.updateDate;
        this.UpdateStr = listingDetail.updateStr;
        this.HeatingCoolingType = listingDetail.heatingCoolingType;
        this.VirTourURL = listingDetail.virTourURL;
        this.Utillities = listingDetail.utillities;
        this.SewageGroundSpill = listingDetail.sewagdspsl;
        this.TotalFinishedSqFt = listingDetail.totalFinishedSqFt;
        this.WaterSource = listingDetail.watersourc;
        this.ListStatus = listingDetail.listStatus;
        this.ListStatusCode = listingDetail.listStatusCode;
        this.Type = listingDetail.type;
        this.Style = listingDetail.style;
        this.Community = listingDetail.community;
        this.District = listingDetail.district;
        this.HasBuildingSpecs = listingDetail.hasBuildingSpecs;
        this.Rooms = listingDetail.rooms;
        this.PropOvervw = listingDetail.propOvervw;
        this.PropertyImages = listingDetail.propertyImages;
        this.Agents = listingDetail.agents.map((agentObj: any) => new Agent(agentObj));
        this.ListingOfficeName = listingDetail.listingOfficeName;
        this.OpenHouses = listingDetail.openHouses;
        this.HasFlyer = listingDetail.hasFlyer;
        this.FlyerUrl = listingDetail.flyerUrl;
        this.BuildingAge = listingDetail.buildingAge;
        this.SqFootage = listingDetail.sqFootage;
        this.NumBeds = listingDetail.numBeds;
        this.FullBaths = listingDetail.fullBaths;
        this.HalfBaths = listingDetail.halfBaths;
        this.PropDir = listingDetail.propDir;
        this.Foundation = listingDetail.foundation;
        this.Roof = listingDetail.roof;
        this.ExternalFinish = listingDetail.externalFinish;
        this.Flooring = listingDetail.flooring;
        this.GarageDetails = listingDetail.garageDetails;
        this.Inclusions = listingDetail.inclusions;
        this.Exclusions = listingDetail.exclusions;
        this.HasLatitudeLongitude = listingDetail.hasLatitudeLongitude;
        this.PostalCode = listingDetail.postalCode;
        this.ExpireDate = listingDetail.expireDate;
        this.ExpireDateStr = listingDetail.expireDateStr;
        this.DaysOnMarket = listingDetail.daysOnMarket;

        if (this.ListStatusCode === 2 && this.FirmDate !== null) {
            const firmDateAsStr: any = this.FirmDate;
            const firmDate = new Date(firmDateAsStr);
            const listDate = new Date(this.ListDate);

            const timeInMilisec: number = firmDate.getTime() - listDate.getTime();
            const daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));

            this.DaysOnMarket = daysBetweenDates;
        } else {
            const listDate = new Date(this.ListDate);

            const timeInMilisec: number = new Date().getTime() - listDate.getTime();
            const daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
            this.DaysOnMarket = daysBetweenDates;
        }

        this.Brokerage = listingDetail.brokerage;
        this.ListingOfficeId = listingDetail.listingOfficeId;
        this.ElemSchool = listingDetail.elemSchool;
        this.ElemSchoolFr = listingDetail.elemSchoolFr;
        this.MidSchool = listingDetail.midSchool;
        this.MidSchoolFr = listingDetail.midSchoolFr;
        this.HighSchool = listingDetail.highSchool;
        this.HighSchoolFr = listingDetail.highSchoolFr;
        this.CondoFee = listingDetail.condoFee;
        this.NewConstruction = listingDetail.newConstruction;
    }
}

